import * as React from "react";
import { useNotification } from "../../context/notification-provider";
import { useDialogs } from "../dialog/use-dialog";
import { WatchListData } from "./types";
import { deleteFromWatchList } from "./watch-list-service";

const WatchListDelete = ({
  selectedWatchList,
  open,
  onClose,
}: {
  selectedWatchList: WatchListData;
  open: boolean;
  onClose: () => void;
}) => {
  const { showNotification } = useNotification();
  const { confirm } = useDialogs();

  const hasOpenedRef = React.useRef(false);

  React.useEffect(() => {
    if (!open || hasOpenedRef.current) return;

    hasOpenedRef.current = true;

    const run = async () => {
      try {
        const result = await confirm(
          <div>
            Are you sure you want to delete{" "}
            <b>{selectedWatchList.description}</b>? This action cannot be
            undone.
          </div>,
          {
            title: "Confirm WatchList Deletion",
            okText: "Delete",
            cancelText: "Cancel",
            severity: "error",
          },
        );

        if (result === true) {
          try {
            await deleteFromWatchList({
              id: selectedWatchList.id,
              entityTypeId: selectedWatchList.entityType.id,
            });
            showNotification({
              message: "Watchlist deleted successfully.",
              severity: "success",
              duration: 3000,
            });
          } catch (err) {
            showNotification({
              message: `Failed to delete watchlist. Reason: ${(err as Error).message}`,
              severity: "error",
              duration: 3000,
            });
          }
        }
      } catch {
        showNotification({
          message: "Failed to show confirmation dialog.",
          severity: "error",
          duration: 3000,
        });
      } finally {
        onClose();
        hasOpenedRef.current = false;
      }
    };

    run();
  }, [open, confirm, selectedWatchList, showNotification, onClose]);

  return null;
};

export default WatchListDelete;
